import { logger } from "../../../core";
import datasourceApiManager from "../DatasourceApiService";
import { AddConnectionRequest, AddConnectionResponse, JobStatusResponse } from "./types";

class ConnectorApiService {
  readonly BASE_URL: string = "/connector-service/api/v2/connectors";

  async addConnection(connection: AddConnectionRequest): Promise<AddConnectionResponse> {
    try {
      const response = await datasourceApiManager
        .getDefault()
        .post<AddConnectionResponse, AddConnectionRequest>(`${this.BASE_URL}/addConnection`, connection);
      return response.data;
    } catch (error) {
      logger.error("ConnectorApiService", "Error adding connection", error);
      throw error;
    }
  }

  async getIngestionStatus(jobId: string): Promise<JobStatusResponse> {
    try {
      const response = await datasourceApiManager
        .getDefault()
        .get<JobStatusResponse>(`${this.BASE_URL}/jobStatus/v2/${jobId}`);
      return response.data;
    } catch (error) {
      logger.error("ConnectorApiService", "Error getting job status", error);
      throw error;
    }
  }
}

const connectorApiService = new ConnectorApiService();
export default connectorApiService;
